<div class="overlay animated fadeIn" *ngIf="this.parent.hasSearchResults()" (click)="this.parent.closeSearchResults();"></div>

<div>
<div class="WelcomeTitle">
  {{'PriceListWelcomeTitle' | translate}}
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllPricesNetPrices' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'RFQBasicInfo' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllGreenPOPossibility' | translate}}</span>
</div>

<div class="ListPriceBrandsContainer">
  <div *ngIf="this.loadingBrandIcons != true;">
    <div class="ListPriceBrand" *ngFor="let b of this.Brands; let i = index;" matTooltip="({{b.Name}}) {{'AvailableUntil' | translate}}: {{b.AvailabilityDateUI}}" matTooltipClass='neutral-tool-tip'>
      <div class="BrandImage">
        <img [src]="this.parent.BackendServiceUrl + b.LogoPath">
      </div>
      <div class="BrandEventRegister">
        {{b.Name}}
      </div>
      <div class="BrandEventRegister">
        {{'AvailableUntil' | translate}}
      </div>
      <div class="BrandEventRegister">
        {{b.AvailabilityDateUI}}
      </div>
    </div>
  </div>
  <div *ngIf="this.loadingBrandIcons == true;" class="brandSpinnerContainer">
    <mat-spinner class="brandSpinner" [diameter]="25"></mat-spinner>
  </div>
</div>

<!-- <div class="WelcomeMessage" *ngIf="this.ShowSearchProductsPageMessage == true && this.B2BHomePageMessage?.length > 0;">
  <div class="WelcomeMessageTitle unSelectable">
    <i class="material-icons">info_outline</i>
    {{'Notice' | translate}}
  </div>
  <div class="WelcomeMessageClose" (click)="CloseShowSearchProductsPageMessage();">
    <i class="material-icons">close</i>
  </div>
  <div class="WelcomeMessageBody">
    {{this.B2BHomePageMessage}}
  </div>
</div> -->

<div class="overlay dashOverlay" *ngIf="this.parent.itemOverlay == true;" (click)="this.parent.CloseItemOverlay();"></div>

<!-- <div class="B2BBodyTopSearchContainer">
    <p class="B2BBodyTopSearchContainerTitle">{{'SearchProducts' | translate}}</p>
    <div class="CentralSearchContainer">
      <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
      <input type="text" class="CentralSearch" placeholder="ex: 6GK5005-0BA00-1AB2" (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
      <i class="material-icons" *ngIf="!(this.Filter?.SearchTerm?.length > 0) && !loadingProducts;">search</i>
      <i class="material-icons" style="color:red;" *ngIf="this.Filter?.SearchTerm?.length > 0 && !loadingProducts;" (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>
    
      <div class="CentralSearchResultsContainer" *ngIf="SearchedProducts?.length > 0;">
        <div *ngFor="let p of this.SearchedProducts;" class="CentralSearchResult" (click)="this.parent.AddNewCartItem(p); this.SearchedProducts = [];">
          {{p.FKBrandName}} {{p.ProductName}}
          <span *ngIf="p.ProductPartNumber?.length > 0 && p.ProductPartNumber != p.Name;">({{p.ProductPartNumber}})</span>
        </div>
      </div>
    </div>
</div> -->

<div class="ColorGuideContainer">

  <div class="ColorGuideContainerTitle">
    <i class="material-icons">info_outline</i>
    <span>{{'UsageInstructions' | translate}}</span>
  </div>

  <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #32aa3a;">
    </div>
    <div class="ColorGuideSpan" style="background: #d2fed2;">
      {{'ValidRow' | translate}}
    </div>
  </div>

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #aaa;">
    </div>
    <div class="ColorGuideSpan" style="background: #ddd;color: #000;">
      {{'InvalidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #ff8987!important;">
    </div>
    <div class="ColorGuideSpan" style="background: #ff8987!important;color: #000;">
      {{'UnknownProduct' | translate}}
    </div>
  </div> -->

  <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #f60;">
    </div>
    <div class="ColorGuideSpan" style="background: #ffcaa1;color: #000;">
      {{'AwaitingSelectionRow' | translate}}
    </div>
  </div>
</div>

<div class="GridTotals" *ngIf="this.parent.Cart?.Currency?.ID > 0;">
   <span class="IntegerSpan" style="margin-right: 10px;">Total:</span> <span class="IntegerSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}</span><span class="DecimalSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}}</span><span class="IntegerSpan">{{this.parent.Cart?.Currency?.Name}}</span> 
   <div class="GridTotalsDisclaimerContainer">
    <i class="material-icons">lightbulb</i>
    <i class="material-icons">email</i>
    <span class="GridTotalsDisclaimerContainerInfo" matTooltip="{{'ForEmailOrdersDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
      {{'ForEmailOrders' | translate}}: orders@foxline.ro
    </span>
   </div>
  </div>

<div class="GridCommandCenter">
 
  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #4d148c;" (click)="this.parent.ExportB2BGrid();">
    <i class="material-icons">downloading</i>
    <span>{{'DownloadExcel' | translate}}</span>
  </button>

  <button mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" (click)="this.parent.DownloadOfficialOffer();">
    <i class="material-icons">attach_file</i>
    <span>{{'DownloadOfficialOffer' | translate}}</span>
  </button>

  <button disabled="true" mat-flat-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID == -1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 0;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button disabled="true" mat-stroked-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID != 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">check</i>
    <span>{{'SendPO' | translate}}</span>
  </button>

  <button (click)="this.parent.OpenAskAddNewRFQasPOQuestion();" mat-stroked-button color="primary" class="AddRowsButton AddNewPOButton" style="color: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">check</i>
    <span>{{'SendPO' | translate}}</span>
  </button>

  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #fd4f57; float: right;" (click)="this.parent.AskClearGridQuestion();">
    <i class="material-icons">close</i>
    <span>{{'ClearGrid' | translate}}</span>
  </button>

  <!-- <mat-form-field class="OfferPriorityStatusesSelect" appearance="outline">
    <mat-label>{{ 'SelectOfferPriority' | translate }}</mat-label>
    <mat-select name="Language" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.OfferPriorityStatus">
      <mat-option *ngFor="let prio of this.parent.OfferPriorityStatuses; index as i" [value]="prio">
        {{prio.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
</div>

<div *ngIf="canRenderSpreadsheet" class="spreadsheetClass">
  <div #spreadsheet></div>
</div>
</div>